export const SHORT_ZIP_CODE = /^[0-9]{5}$/;
export const LONG_ZIP_CODE = /^(\d{5}|\d{5}-\d{4})$/;
